import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Switch from '@material-ui/core/Switch'
import Typography from '@material-ui/core/Typography'
import { ToggleButtonGroup } from '@material-ui/lab'
import SegmentedToggleButton from 'components/segmented-toggle-button'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from 'components/error'
import { RefetchContext } from 'lib/utils/refetchContext'
import EventsPageData from './event-components/events-show-page'
import FreeTierLimitDialog from './free-tier-limit-dialog'
import useStyles from './styles'

export const GroupEventsTabs = ({
  selectedTab,
  setSelectedTab,
  showCanceledEvents,
  setShowCanceledEvents,
  inline = false,
}) => {
  const classes = useStyles()
  const tabs = (
    <Box className={classes.tabWrapper}>
      <ToggleButtonGroup
        exclusive
        size="small"
        color="primary"
        value={selectedTab}
        onChange={(_, newValue) => {
          if (newValue !== null) setSelectedTab(newValue)
        }}
        className={classes.segmentControl}
        aria-label="Group events timeframe"
      >
        <SegmentedToggleButton
          value="upcoming"
          groupValue={selectedTab}
          aria-label="Upcoming"
        >
          Upcoming
        </SegmentedToggleButton>
        <SegmentedToggleButton
          value="past"
          groupValue={selectedTab}
          aria-label="Past"
        >
          Past
        </SegmentedToggleButton>
      </ToggleButtonGroup>
      <Box>
        <FormControlLabel
          className={classes.showCancellations}
          size="size"
          control={
            <Switch
              checked={showCanceledEvents}
              onChange={e => setShowCanceledEvents(e.target.checked)}
            />
          }
          label={<Typography variant="button">Show Cancellations</Typography>}
        />
      </Box>
    </Box>
  )

  if (inline) {
    return tabs
  }

  return <Container className={classes.containerStyles}>{tabs}</Container>
}

const GroupEventsPanel = ({ panel, showInlineTabs = false }) => {
  const {
    selectedTab,
    setSelectedTab,
    showCanceledEvents,
    setShowCanceledEvents,
    offset,
    setOffset,
    showLimitReachedDisclaimer,
    setShowLimitReachedDisclaimer,
    openFreeTierLimitDialog,
    setOpenFreeTierLimitDialog,
    isPgaHopeCoach,
    setIsPgaHopeCoach,
    data,
    loading,
    error,
    refetch,
  } = panel

  return (
    <>
      {showInlineTabs ? (
        <GroupEventsTabs
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          showCanceledEvents={showCanceledEvents}
          setShowCanceledEvents={setShowCanceledEvents}
          inline
        />
      ) : null}
      {loading && <LinearProgress color="primary" />}
      {error && <Error />}
      {!loading && !error && (
        <RefetchContext.Provider value={refetch}>
          <EventsPageData
            eventsData={data}
            selectedTab={selectedTab}
            showCanceledEvents={showCanceledEvents}
            offset={offset}
            setOffset={setOffset}
            showLimitReachedDisclaimer={showLimitReachedDisclaimer}
            setShowLimitReachedDisclaimer={setShowLimitReachedDisclaimer}
            setIsPgaHopeCoach={setIsPgaHopeCoach}
          />
          <FreeTierLimitDialog
            open={openFreeTierLimitDialog}
            setOpen={setOpenFreeTierLimitDialog}
            isPgaHopeCoach={isPgaHopeCoach}
          />
        </RefetchContext.Provider>
      )}
    </>
  )
}

export default GroupEventsPanel
